import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  addPeriod,
  removePeriod,
  editPeriod,
  movePeriod,
} from 'actions/accountsActions';
import { openModal } from 'actions/modalActions';
import { v4 as uuid } from 'uuid';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import { periodsSelector } from 'selectors/periods';

class PeriodsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      numberOfDays: null,
    };
  }

  render() {
    const { periods } = this.props;

    return (
      <div className="PeriodsModal">
        <h2>Periods</h2>
        <PeriodsList
          periods={periods}
          helperClass="SortableHelper"
          onSortEnd={this.handleSortPeriods}
          onEditPeriod={this.handleEditPeriod}
          onRemovePeriod={this.removePeriod}
          lockAxis="y"
          useDragHandle={true}
          pressThreshold={0}
        />
        <form onSubmit={this.handleAddPeriod}>
          <input
            name="name"
            autoComplete="off"
            type="text"
            value={this.state.name}
            onChange={(event) => this.handleInputChange(event)}
            placeholder="Name"
          />
          <input
            name="numberOfDays"
            autoComplete="off"
            type="number"
            value={this.state.numberOfDays || ''}
            onChange={(event) => this.handleInputChange(event)}
            placeholder="Number of days (optional)"
            min={1}
          />
          <input
            type="submit"
            value="Add period"
            className="btn"
            disabled={!this.state.name}
          />
        </form>
      </div>
    );
  }

  handleSortPeriods = ({ oldIndex, newIndex }) => {
    this.props.movePeriod(oldIndex, newIndex);
  };

  handleInputChange = (event) => {
    const name = event.target.name;
    this.setState({
      [name]: event.target.value,
    });
  };

  handleEditPeriod = (event, periodId) => {
    this.props.editPeriod(periodId, {
      [event.target.name]: event.target.value,
    });
  };

  removePeriod = (periodId) => {
    this.props.openModal({
      id: uuid(),
      type: 'confirmation',
      text:
        'Are you sure you want to remove period? Period information in accounts and journals will be lost if the period is removed.',
      onConfirm: () => {
        this.props.removePeriod(periodId);
      },
    });
  };

  handleAddPeriod = (event) => {
    const { name, numberOfDays } = this.state;
    this.props.addPeriod(name, numberOfDays);
    this.setState({
      name: '',
      numberOfDays: null,
    });
    event.preventDefault();
  };
}

export default connect(
  (state) => ({
    periods: periodsSelector(state),
  }),
  { addPeriod, removePeriod, editPeriod, movePeriod, openModal }
)(PeriodsModal);

const DragHandle = SortableHandle(() => <span>&nbsp;</span>);

const Period = SortableElement(({ period, onEditPeriod, onRemovePeriod }) => (
  <div className="draggable-period-item">
    <DragHandle />
    <input
      name="name"
      autoComplete="off"
      type="text"
      value={period.name}
      onChange={(event) => onEditPeriod(event, period.id)}
      placeholder="Name"
    />
    <input
      name="numberOfDays"
      autoComplete="off"
      type="number"
      value={period.numberOfDays}
      onChange={(event) => onEditPeriod(event, period.id)}
      placeholder="Number of days (optional)"
      min={1}
    />
    <button type="button" onClick={() => onRemovePeriod(period.id)}>
      ×
    </button>
  </div>
));

const PeriodsList = SortableContainer(
  ({ periods, onEditPeriod, onRemovePeriod }) => {
    return (
      <div className="PeriodsList">
        <div>
          {periods.map((period, index) => (
            <Period
              key={`item-${index}`}
              index={index}
              onEditPeriod={onEditPeriod}
              onRemovePeriod={onRemovePeriod}
              period={period}
            />
          ))}
        </div>
      </div>
    );
  }
);
